import { Action } from '@ngrx/store';
import { TableState } from '@model';

export enum CustomersTableActionTypes {
  CustomersUsersPageChange = '[CustomersTable] Users Table Changed',
  CustomerInvitationsPageChange = '[CustomersTable] Invitations Table Changed',
  CustomersTableStateReset = '[CustomersTable] State reset',
  CustomersPageChange = '[CustomersTable] Customers Table Changed',
  UserCustomersPageChange = '[CustomersTable] User Customers Table Changed'
}

export class CustomersUsersPageChange implements Action {
  readonly type = CustomersTableActionTypes.CustomersUsersPageChange;
  constructor(public payload: TableState) {}
}

export class CustomerInvitationsPageChange implements Action {
  readonly type = CustomersTableActionTypes.CustomerInvitationsPageChange;
  constructor(public payload: TableState) {}
}

export class CustomersTableStateReset implements Action {
  readonly type = CustomersTableActionTypes.CustomersTableStateReset;
  constructor() {}
}

export class CustomersPageChange implements Action {
  readonly type = CustomersTableActionTypes.CustomersPageChange;
  constructor(public payload: TableState){}
}

export class UserCustomersPageChange implements Action {
  readonly type = CustomersTableActionTypes.UserCustomersPageChange;
  constructor(public payload: TableState){}
}

export type CustomersTableActions = CustomersUsersPageChange | CustomerInvitationsPageChange | CustomersTableStateReset | CustomersPageChange | UserCustomersPageChange;
